import InitialState from "./InitialState"
import { SAVE_EXERCISES, SET_USER_FITNESS_PLAN_DETAILS } from "../actions/ActionTypes";
import { ISelectOption } from "../components/common/SearchableSelect/SearchableSelect";

interface UserFitnessAction {
    type: string,
    exercises: ISelectOption[]
    userFitnessPlan: any;
    userFitnessPlanStartDate: any;
    userProfile: any;
    isPublishedPlan: boolean;
}

export const UserFitnessReducer = function (state = InitialState.fitnessData, action: UserFitnessAction) {
    switch (action.type) {
        case SAVE_EXERCISES:
            return {
                ...state,
                exercises: action.exercises
            }
        case SET_USER_FITNESS_PLAN_DETAILS: {
            return {
                ...state,
                userFitnessPlan: action.userFitnessPlan,
                userFitnessPlanStartDate: action.userFitnessPlanStartDate,
                userProfile: action.userProfile,
                isPublishedPlan: action.isPublishedPlan
            }
        }
        default:
            return state;
    }
}